import React, { useState } from "react";
import { LuMapPin } from "react-icons/lu";
import Addresspop from "../addresspopup/Addresspop";

const DeleveryAddress = ({ setAddress, Address }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [model, setModel] = useState(false);


  
  return (
    <div className="w-full flex flex-col mt-7">
      <div className="w-full">
        <span className="text-textColor font-semibold  title1 text-base"
        >
          Delivery Address
        </span>
      </div>
      <div className="mt-4 bg-[#F6F7F3] rounded-2xl px-4 py-5 flex gap-2 justify-between">
        <div className="flex gap-3 w-full items-center">
          <LuMapPin className="text-2xl text-textColor" />
          <input
            type="text"
            className="w-full p-2 text-[14px] bg-[#F6F7F3] text-gray-600"
            value={
              Address?.house_number && Address?.society_name
                ? `${Address.house_number} ${Address.society_name}`
                : "Select Address"
            }
            required
            readOnly
          />
        </div>
        <div>
          <button
            className="bg-textColor text-[12px] text-white w-24 rounded-3xl py-2"
            onClick={() => {
              setModel(!model);
            }}
          >
            Select
          </button>
        </div>
      </div>
      {model && (
        <Addresspop
          setModel={setModel}
          setAddress={setAddress}
          setSelectedIndex={setSelectedIndex}
          selectedIndex={selectedIndex}
        />
      )}
    </div>
  );
};

export default DeleveryAddress;
